var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 423.725H8.828A8.829 8.829 0 0 1 0 414.897V97.104a8.829 8.829 0 0 1 8.828-8.828h494.345a8.829 8.829 0 0 1 8.828 8.828v317.793a8.83 8.83 0 0 1-8.829 8.828z",
    fill: "#73af00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffe15a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.049 224.981c-.236-1.508-2.423-1.433-2.595.084-5.266 46.402-44.626 82.453-92.452 82.453-47.811 0-87.185-36.051-92.452-82.451-.172-1.517-2.359-1.593-2.595-.084a92.275 92.275 0 0 0-1.132 14.315c-.001 53.068 43.069 96.151 96.179 96.151 53.128 0 96.18-43.083 96.18-96.151a92.805 92.805 0 0 0-1.133-14.317z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.81 185.268l-6.955 20.854-21.983.17c-1.205.009-1.705 1.547-.735 2.263l17.685 13.059-6.631 20.96c-.363 1.149.945 2.1 1.926 1.399L256 231.19l17.885 12.783c.981.701 2.289-.249 1.926-1.399l-6.631-20.96 17.685-13.059c.97-.716.47-2.254-.735-2.263l-21.983-.17-6.955-20.854c-.383-1.143-2.001-1.143-2.382 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMr);
export default __webpack_public_path__ + "static/media/mr.5830d95fb89b32eef9126f9b4ebac00a.svg";
export { ForwardRef as ReactComponent };